export var VaultLockServiceEvent;
(function (VaultLockServiceEvent) {
    VaultLockServiceEvent["VaultUnlocked"] = "VaultUnlocked";
    VaultLockServiceEvent["VaultLocked"] = "VaultLocked";
})(VaultLockServiceEvent || (VaultLockServiceEvent = {}));
